import React from 'react';
import styles from './MenuItemList.module.css';

const MenuItemList = ({items = []}) => {
    // Max 2 columns, first column has at least 4 items
    let columns = [];

    if (items.length <= 4) {
        columns = [items];
    } else {
        const half = Math.ceil(items.length / 2);
        const firstCount = half < 4 ? 4 : half; // ensure at least 4 in first
        const firstCol = items.slice(0, firstCount);
        const secondCol = items.slice(firstCount);
        columns = [firstCol];
        if (secondCol.length) columns.push(secondCol); // only add if not empty
    }

    const isSingleColumn = columns.length === 1;

    return (
        <div className={styles['menu-list-card']}>
            <div className={styles['menu-list-columns']}>
                {columns.map((col, index) => (
                    <ul
                        key={index}
                        className={`${styles['menu-list-column']} ${
                            !isSingleColumn && index !== columns.length - 1 ? styles['with-divider'] : ''
                        }`}>
                        {col.map((item, i) => (
                            <li key={i}>{item}</li>
                        ))}
                    </ul>
                ))}
            </div>
        </div>
    );
};

export default MenuItemList;
